export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/divider.be36ab04-d75837.svg";